<script setup lang="ts">
defineOptions({
  name: 'BoardSubTitle',
  inheritAttrs: false,
})

defineProps<{
  id?: string
  icon?: string
  title?: string
  subtitle?: string
}>()
</script>

<template>
  <p
    class="board-sub-title pt-16 font-title text-lg font-bold"
    :class="{ 'pb-4': !$slots.subtitle, 'pb-2': $slots.subtitle }"
  >
    <DIcon
      v-if="icon"
      :path="icon"
    /><slot>
      {{ title }}
    </slot>
  </p>
  <p
    v-if="$slots.subtitle || subtitle"
    class="text-sm text-grey-400 pb-4"
  >
    <slot name="subtitle">
      {{ subtitle }}
    </slot>
  </p>
</template>
